<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <button mat-icon-button (click)="goBack()" class="back-btn">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Participantes</span>
  <span class="spacer"></span>
  <button
    mat-icon-button
    (click)="sendPaymentReminders()"
    title="Enviar recordatorios de formalización"
  >
    <mat-icon>notifications</mat-icon>
  </button>
</mat-toolbar>

<div class="ul-wrapper">
  @if (users) {
    <!-- Stats strip -->
    <div class="ul-stats">
      <div class="ul-stat">
        <span class="ul-stat__value">{{ users.length }}</span>
        <span class="ul-stat__label">Participantes</span>
      </div>
      <div class="ul-stat-divider"></div>
      <div class="ul-stat">
        <span class="ul-stat__value success">{{ paidCount }}</span>
        <span class="ul-stat__label">OK</span>
      </div>
      <div class="ul-stat-divider"></div>
      <div class="ul-stat">
        <span class="ul-stat__value danger">{{
          users.length - paidCount
        }}</span>
        <span class="ul-stat__label">No OK</span>
      </div>
    </div>

    <!-- User list -->
    <div class="ul-list">
      @for (user of users; track user) {
        <div class="ul-card">
          <div class="ul-card__avatar" (click)="editUser(user)">
            <app-avatar [user]="user"></app-avatar>
          </div>
          <div class="ul-card__info" (click)="editUser(user)">
            <span class="ul-card__name">{{ user.name }}</span>
            <!-- <span
              class="ul-card__badge"
              [class.paid]="user.hasPaid"
              [class.unpaid]="!user.hasPaid"
            >
              {{ user.hasPaid ? "Formalizado" : "Sin formalizar" }}
            </span> -->
          </div>
          <div class="ul-card__actions">
            <button
              class="ul-action-btn"
              [class.paid]="user.hasPaid"
              [class.unpaid]="!user.hasPaid"
              (click)="togglePayment(user)"
              title="Cambiar estado de formalización"
            >
              <mat-icon>how_to_reg</mat-icon>
            </button>
            <button
              class="ul-action-btn ul-action-btn--delete"
              (click)="delete(user)"
              title="Eliminar usuario"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
